export default __webpack_public_path__ + "static/media/document-analytics-icon.11ac2a4f.svg";